// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sb-media_wrapper___MkSK","desktop":"sb-media_desktop__gvGlu","mobile":"sb-media_mobile__m1xAy"};